var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useField } from 'formik';
import React from 'react';
import NumberFormat from 'react-number-format';
import InlineTextField from './InlineTextField';
export const InlineNumberField = (_a) => {
    var { name, type = 'tel', // force number input on mobile
    prefix, format, phoneNumber, creditcard, length, min, max, isNumericString, thousandSeparator, currency, grid = { xs: 12 }, helperText, variant = 'outlined' } = _a, props = __rest(_a, ["name", "type", "prefix", "format", "phoneNumber", "creditcard", "length", "min", "max", "isNumericString", "thousandSeparator", "currency", "grid", "helperText", "variant"]);
    const [field, meta, { setValue }] = useField(name);
    if (creditcard) {
        format = '#### #### #### ####';
    }
    else if (phoneNumber) {
        format = '+1 (###) ###-####';
        // } else if (forceLeadingZero && length) {
        //   format = value =>
        //     value.length < length
        //       ? [...Array(length - value.length + 1)].join('0') + value
        //       : value;
    }
    else if (currency) {
        // TODO: implement props to customize as well as context to theme globally
        prefix = '$';
        thousandSeparator = true;
    }
    else if (!format && length) {
        format = [...Array(length + 1)].join('#');
        if (prefix)
            format = prefix + format;
    }
    return (React.createElement(NumberFormat, Object.assign({}, props, { overrideBlur // important to override NumberFormat blur
        : true, type: type, prefix: prefix, variant: variant, format: format, min: min, max: max, grid: grid, value: field.value, thousandSeparator: thousandSeparator, isNumericString: isNumericString, onValueChange: values => {
            // determine if we should return a number or a string
            let value = values.floatValue;
            if (typeof (field === null || field === void 0 ? void 0 : field.value) === 'number' || (field === null || field === void 0 ? void 0 : field.value) === null) {
                // must return a number otherwise `diff()` will break
                value =
                    typeof values.floatValue === 'number' ? values.floatValue : null;
            }
            else {
                value = values.value || null;
            }
            if (isNumericString) {
                value =
                    typeof value === 'number' || typeof value === 'string'
                        ? value.toString()
                        : '';
            }
            setValue(value);
        }, customInput: InlineTextField, error: Boolean(props.error) || (meta.touched && Boolean(meta.error)), helperText: meta.error || helperText, name: name })));
};
export default InlineNumberField;
//# sourceMappingURL=InlineNumberField.js.map